export default __webpack_public_path__ + "static/media/schultemix_standard.920fdaf0.svg";